import { css } from '@inter-ikea-kompis/web-component';
export default class LanguageSelectorStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing } = options.theme;
        return css `
			:host {
				position: relative;
				display: inline-block;
			}

			kompis-popover {
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
			}

			kompis-popover-padding {
				max-width: ${284 / 16}rem;
				width: calc(100vw - ${spacing.space150 / 16}rem);
				padding: ${spacing.space150 / 16}rem;
			}

			.spacer {
				height: ${spacing.space100 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=LanguageSelectorStyle.js.map